<template>
    <!-- Opportunities -->
    <div class="flex-1 flex flex-col gap-6">
        <h1 class="md:text-4xl sm:text-3xl text-3xl font-semibold mb-4 text-gray-50">Opportunities</h1>
        <div v-if="loading" class="flex items-center justify-center py-10">
            <svg class="animate-spin h-5 w-5 text-blue-500 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>
            <span class="text-gray-200 text-sm">Loading opportunities...</span>
        </div>
        <div v-else>
            <div v-if="opp && opp.length > 0" class="flex flex-col justify-start items-start gap-8">
                <opportunity-card
                    v-for="(item, index) in opp"
                    :key="index"
                    :opportunity="item"
                    class="w-full"
                />
            </div>
            <div v-else class="flex flex-col items-center justify-center py-10 text-center text-gray-400">
                <svg class="w-10 h-10 mb-3 text-gray-600" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 15l5 5m-5-5a6 6 0 111.414-1.414L20 20"></path>
                </svg>
                <span class="text-lg">No opportunities found</span>
                <p class="text-sm text-gray-500 mt-1">Try adjusting your filters or search query.</p>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { watch, ref, onMounted } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import api from '@/utils/api'
    import OpportunityCard from './OpportunityCard'
  
    const router = useRouter()
    const route = useRoute()
    const loading = ref(true)
    const opp = ref({})

    const getOpportunities = async () => {
        try {
            const response = await api.get('opportunities/index', {
                params: {
                    categories: route.query.categories
                }
            })

            if (response.data.status == 'error')
            {
                router.push({
                    path: '/'
                })
            }


            if (response.status == 200)
            {
                opp.value = response.data.data.data
            }
        } catch (error) {
            console.error('API error:', error)
        } finally {
            loading.value = false
        }
    }

    onMounted(getOpportunities)
    watch(() => route.query.categories, () => {
        loading.value = true
        getOpportunities()
    })
</script>